import { Input } from '@/common/ui/input'
import { cn } from '@/common/lib/utils'
import { Button } from '../button'
import { Search, X } from 'lucide-react'
import { useCallback } from 'react'
import { useQueryState, parseAsString } from 'nuqs'

interface DataTableSimpleSearchProps {
	placeHolder: string
	queryKey?: string
}

export function DataTableSimpleSearch({
	placeHolder,
	queryKey = 'q',
}: DataTableSimpleSearchProps) {
	const [searchQuery, setSearchQuery] = useQueryState(
		queryKey,
		parseAsString.withOptions({ shallow: false }).withDefault(''),
	)

	const handleSearchChange = useCallback(
		(value: string) => {
			setSearchQuery(value || null)
		},
		[setSearchQuery],
	)

	const handleClear = useCallback(() => {
		setSearchQuery(null)
	}, [setSearchQuery])

	return (
		<div className="flex items-center space-x-2">
			<div className="relative">
				<Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
				<Input
					placeholder={placeHolder}
					value={searchQuery ?? ''}
					onChange={(e) => handleSearchChange(e.target.value)}
					className={cn('w-full pl-8 md:max-w-sm')}
				/>
				{searchQuery && (
					<Button
						variant="ghost"
						size="sm"
						className="absolute right-1 top-1 h-6 w-6 p-0"
						onClick={handleClear}
					>
						<X className="h-3 w-3" />
					</Button>
				)}
			</div>
		</div>
	)
}
